import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) { toast.error(formatError(err.response?.data?.detail) || "Login failed"); }
    finally { setBusy(false); }
  };

  const input = "w-full rounded-lg border border-slate-600 bg-[#0C131F] p-3 text-slate-100 placeholder:text-slate-500 focus:border-[#E8A317] focus:outline-none focus:ring-1 focus:ring-[#E8A317]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0C131F] px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-slate-700 bg-[#151F30] p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="flex flex-col items-center">
          <Logo className="h-16 w-16" />
          <h1 className="mt-4 font-heading text-2xl font-extrabold uppercase text-white">BJRC Admin</h1>
          <p className="text-sm text-slate-400">Secure club management portal</p>
        </div>
        <div className="mt-8 space-y-4">
          <input required type="email" placeholder="Email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          <input required type="password" placeholder="Password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          <button type="submit" disabled={busy} data-testid="admin-login-button" className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#E8A317] py-3 font-extrabold uppercase text-[#0A1626] hover:bg-[#CC8F12] disabled:opacity-60">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-5 w-5" />} Sign In
          </button>
        </div>
      </form>
    </div>
  );
}
